<template>
    <IdeoFormGroup :label="$t('[[[Parametr zoneid]]]')" :invalid-feedback="form.$errors.first('zoneid')" :state="form.$errors.state('zoneid')">
        <IdeoFormInput v-model="form.settings.zoneid" type="number" name="zoneid" />
    </IdeoFormGroup>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('isBlockcampaign')" :state="form.$errors.state('isBlockcampaign')">
        <IdeoFormCheckbox v-model="form.settings.isBlockcampaign" switch>
            {{ $t('[[[Parametr blockcampaign]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <div class="row">
        <div class="col">
            <IdeoFormGroup :label="$t('[[[Blok zaślepki]]]')" :invalid-feedback="form.$errors.first('placeholderBlockId')" :state="form.$errors.state('placeholderBlockId')">
                <IdeoAutocomplete
                    v-model="form.settings.placeholderBlockId"
                    name="placeholderBlockId"
                    track-by="id"
                    :placeholder="$t('[[[Zacznij pisać aby wyszukać zaślepkę...]]]')"
                    :default-label="$t('[[[Brak zaślepki]]]')"
                    :fetch="(id: number) => fetchPlaceholder(id)"
                    :search="(query: string, limit: number) => searchPlaceholder(query, limit)"
                >
                    <template #selected="{ option }">
                        <div class="text-wrap">
                            {{ option.name }}
                        </div>
                    </template>
                    <template #option="{ option }">
                        <div class="text-wrap">
                            {{ option.name }}
                        </div>
                    </template>
                </IdeoAutocomplete>
            </IdeoFormGroup>
        </div>
    </div>
</template>

<script lang="ts" setup>
import merge from 'lodash-es/merge';
import type { WidgetModel } from '#layers/core/app/pages/account/dashboards/_runtime/services/DashboardsService';
import WidgetsService from '#layers/prawopl/app/runtime/services/WidgetsService';
import { useWebsitesStore } from '#layers/cms/app/pages/cms/management/websites/_runtime/stores/websites';

defineOptions({
    name: 'AdserverSettings'
});

const props = defineProps<{
    modelValue: any;
    websiteId: number;
    locale: string;
    id: number;
}>();

const emit = defineEmits<{
    (event: 'update:modelValue', value: any): void;
}>();

const websiteStore = useWebsitesStore();

const current = computed<CurrentWebsite>(() =>
{
    return websiteStore.current;
});

const defaults: any = {
    zoneid: null,
    isBlockcampaign: false,
    placeholderBlockId: null
};

const form = ref(props.modelValue);

onMounted(async () =>
{
    form.value.settings = merge(defaults, form.value.settings);
});

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

function triggerModel()
{
    emit('update:modelValue', form.value);
}

const fetchPlaceholder = async (id: number): Promise<WidgetModel> =>
{
    const response = await WidgetsService.fetchAutocompletePlaceholder(current.value.website, current.value.locale, id);

    return response || null;
};

const searchPlaceholder = async (query: string, limit: number): Promise<WidgetModel[]> =>
{
    return await WidgetsService.getAutocompletePlaceholders(current.value.website, current.value.locale, query, limit);
};
</script>
